import { Component, OnInit } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { LivetrainingService } from '../shared/services/livetraining.service';
import { Router } from '@angular/router';
import * as AOS from 'aos';

@Component({
  selector: 'app-livetrainings',
  templateUrl: './livetrainings.component.html',
  styleUrls: ['./livetrainings.component.css']
})
export class LivetrainingsComponent implements OnInit {

  eventDetails: any = [];
  meetingDetails:any=[];
  constructor(
    private service: LivetrainingService,
    public router: Router,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("Live Trainings - SFI Compliance, Inc");
    AOS.init();
    this.getData();
    this.refreshData();    
  }

  goToDetailsPage(id: string): void {
    //this.router.navigateByUrl("/livetrainings/" + id);
    this.router.navigate(["/traininglogin",{id:id}]);
  }

  goToMeetingsPage(id: string): void {
    //this.router.navigateByUrl("/livetrainings/" + id);
    this.router.navigate(["/meetinglogin",{id:id}]);
  }

  async getData(){
    await this.service.getEvents().then(data => {
      this.eventDetails = data;      
      console.log(data);
    });

    await this.service.getLiveMeetings().then(data => {
      this.meetingDetails = data;
    })
  }

  refreshData(){
    
      setInterval(() => {
        //console.log("called");
        this.getData();        
        //Passing the false flag would prevent page reset to 1 and hinder user interaction
      }, 60000);  
  }

}
